<template>
  <div class="vast-service-order-now-modal-footer">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
